module.exports = __webpack_public_path__ + "static/img/award-3 2.c399b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/award-3 2.jpg
// module id = Z0jz
// module chunks = 1